import { useContext } from 'react';
import { RepositoryContext } from "../context/index.js";
/**
 * Returns a Repository instance from the RepositoryContext
 */
export const useRepository = () => useContext(RepositoryContext);
//# sourceMappingURL=use-repository.js.map